<template>

    <form ref="produtopoliticacomercialpreco-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            
                    <div class="form-group col-md-12">
                        <label for="cadastroPoliticaComercialId">CadastroPoliticaComercial</label>
                        <select v-select="{ dataitem: 'CadastroPoliticaComercial', default: 'Selecione' }" v-model="model.cadastroPoliticaComercialId" class="form-control" name="cadastroPoliticaComercialId" required></select>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="estoqueItemId">EstoqueItem</label>
                        <select v-select="{ dataitem: 'EstoqueItem', default: 'Selecione' }" v-model="model.estoqueItemId" class="form-control" name="estoqueItemId" required></select>
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorInstituicaoEnsino">ValorInstituicaoEnsino</label>
                        <input type="text" class="form-control" name="valorInstituicaoEnsino" placeholder="ValorInstituicaoEnsino" v-model="model.valorInstituicaoEnsino"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorAluno">ValorAluno</label>
                        <input type="text" class="form-control" name="valorAluno" placeholder="ValorAluno" v-model="model.valorAluno"  />
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "produtopoliticacomercialpreco-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "produtopoliticacomercialpreco-form-create",
            
            resources: {
                create: 'produtopoliticacomercialpreco',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

